import { css } from '@emotion/react'

export const screens = {
  xs: '22.5rem', // 360px
  sm: '35.5rem', // 568px
  md: '50rem', // 800px
  lg: '64rem', // 1024px
  xl: '112.5rem', // 1800px
}

export default Object.keys(screens).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (min-width: ${screens[label]}) {
      ${css(...args)};
    }
  `
  return acc
}, {})
